export default {
  colors: {
    primary: "#101010",
    secondary: "#fff",
  },
  backgrounds: {
    primary: "#f5f5f5",
    secondary: "#fff",
  },
  breakpoints: {
    tablet: "only screen and (max-width: 768px)",
    mobile: "only screen and (max-width: 670px)",
    xsmobile: "only screen and (max-width: 400px)",
  },
}
